import { render, staticRenderFns } from "./CircleLoader.vue?vue&type=template&id=f2a66340&"
import script from "./CircleLoader.vue?vue&type=script&lang=js&"
export * from "./CircleLoader.vue?vue&type=script&lang=js&"
import style0 from "./CircleLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports